<template>
  <div style="margin: 20px">
    <el-form ref="form" class="card" :model="form" label-width="80px" inline style="height: 5vh">
      <el-form-item label-width="0">
        <el-select v-model="form.SelectType" placeholder="索引方式" @change="form.Page=1">
          <el-option v-for="(item,idx) in selectTypes" :label="item.label" :value="item.value" :key="idx"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="showCode" label="条码">
        <el-input v-model="form.Code" clearable placeholder="条码"></el-input>
      </el-form-item>
      <el-form-item v-if="showDate" label="时间范围">
        <el-date-picker
          v-model="value2"
          type="datetimerange"
          :picker-options="editConfig.pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="text" @click="query">查询</el-button>
      </el-form-item>
    </el-form>
    <div>
      <el-table
        stripe
        v-loading="loading"
        :data="items"
        style="width: 100%;height: calc(100vh - 125px); overflow: auto;"
        class="el-custom-table"
        header-cell-class-name="custom-header-cell">
        <el-table-column
          prop="ytoCode"
          label="条码"
          width="180">
        </el-table-column>
        <el-table-column
          prop="readCodeTime"
          label="读码时间"
          width="180">
        </el-table-column>
        <el-table-column
          prop="latticeTime"
          label="格口获取时间">
        </el-table-column>
        <el-table-column
          prop="latticeNo"
          label="格口">
        </el-table-column>
        <el-table-column
          prop="dropLatticeDataTime"
          label="下包时间">
        </el-table-column>
        <el-table-column
          prop="dropLatticeNo"
          label="下包格口">
        </el-table-column>
        <el-table-column
          prop="dropLatticeDataCar"
          label="小车号">
        </el-table-column>
      </el-table>
    </div>
    <el-pagination style="margin: 5px 0 0 0"
                   @size-change="pageSizeChange"
                   @current-change="pageChange"
                   :current-page="form.Page"
                   :page-sizes="[20, 50, 100, 200]"
                   :page-size="form.PageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="total">
    </el-pagination>
  </div>
</template>

<script>
import editConfig from "./editConfig";
import {from} from "linq";
import {parseTime} from "../../utils";

export default {
  computed: {
    showCode() {
      var arr = [4];
      if (arr.indexOf(this.form.SelectType) >= 0) {
        return true;
      }
      return false
    },
    showDate() {
      var arr = [4];
      if (arr.indexOf(this.form.SelectType) >= 0) {
        return false;
      }
      return true
    }
  },
  mounted() {
  },
  data() {
    return {
      loading: false,
      items: [],
      editConfig: editConfig,
      value2: '',
      form: {SelectType: 1, Start: '', End: '', IncludeHistory: '', Code: '', Page: 1, PageSize: 20},
      selectTypes: [
        {label: '所有条码', value: 1},
        {label: '有格口', value: 2},
        {label: '无格口', value: 3},
        {label: '条码检索', value: 4},
        {label: '无读', value: 5},
        {label: '漏回传', value: 6},
        {label: '多条码', value: 7},
      ],
      total: 0,
    }
  },
  methods: {
    pageSizeChange(val) {
      this.form.Page = 1;
      this.form.PageSize = val;
      this.query();
    },
    pageChange(val) {
      this.form.Page = val;
      this.query();
    },
    async selectFolder() {
      loginfo_core.openFolder().then(res => {
        console.log(res)
      })
    },
    async query() {
      if (this.showCode && !this.form.Code) {
        this.$message.error('请输入单号')
        return false;
      }
      if (this.showDate && !this.value2) {
        this.$message.error('请选择时间')
        return false;
      }
      this.loading = true;
      console.log(this.value2)
      this.form.Start = this.value2[0];
      this.form.End = this.value2[1];
      console.log(this.form);
      let result = await loginfo_core.getLogs(this.form)
      this.total = result.total;
      let items = [];
      for (let i = 0; i < result.items.length; i++) {
        let e = result.items[i]
        let item = {ytoCode: e.YtoCode}
        item.readCodeTime = parseTime(from(e.OptItems).firstOrDefault(f => f.OptType == 'ReadCode')?.OptTime);
        var latticeNo = from(e.OptItems).firstOrDefault(f => f.OptType == 'LatticeNo')
        item.latticeTime = parseTime(latticeNo?.OptTime)
        item.latticeNo = (latticeNo?.OptValue) || '<无>'
        var dropLattice = from(e.OptItems).firstOrDefault(f => f.OptType == 'DropLatticeNo');
        if (dropLattice?.OptTime) {
          item.dropLatticeDataTime = parseTime((dropLattice?.OptTime))
        } else {
          item.dropLatticeDataTime = '<无>'
        }
        item.dropLatticeNo = (dropLattice?.OptValue) || '<无>'

        var dropLatticeDataCarItem = from(e.OptItems).firstOrDefault(f => f.OptType == 'dropLatticeDataCar');
        item.dropLatticeDataCar = (dropLatticeDataCarItem?.OptValue) || '<无>'

        items.push(item)
      }
      this.items = items
      this.loading = false;
    }
  },
}
</script>

<style scoped lang="less">
.card {
  background: @cardBackColor;
}
</style>
